import { render } from "./AddAccountantPage.vue?vue&type=template&id=0af7aa2c&ts=true"
import script from "./AddAccountantPage.vue?vue&type=script&lang=ts"
export * from "./AddAccountantPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/ZaloOA_Phoi/ZaloOA_Phoi_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__